import { createCryptoWorkerPool } from '@op/web-crypto'

export const cryptoWorkerPool = createCryptoWorkerPool(
	Math.max(2, Math.ceil((navigator.hardwareConcurrency - 1) / 2)),
)
